/* TwentySix live search.
   Opens from the header search icons and from the search row of the mobile menu (the menu clicks the header icon).
   Matching happens right here on the phone (assets/ts-search-engine.js over the catalog from
   templates/collection.ts-search-index.liquid), so results change with every letter. Each product shows as the
   site's own card, read from /products/{handle}?section_id=ts-search-card. If the catalog can't load, the store's
   own search (sections/ts-search.liquid) takes over. */
(function () {
  'use strict';
  var root = document.getElementById('tss');
  if (!root || root.__tss) return;
  root.__tss = true;

  var html = document.documentElement;
  var input = root.querySelector('.tss__input');
  var form = root.querySelector('.tss__form');
  var clearBtn = root.querySelector('.tss__clear');
  var scroller = root.querySelector('.tss__body');
  var results = root.querySelector('.tss__results');
  var status = root.querySelector('.tss__status');
  var recent = root.querySelector('.tss-recent');
  var recentList = root.querySelector('.tss-recent__list');
  var newBox = root.querySelector('.tss-new');
  var newRail = root.querySelector('[data-tss-new]');
  var sheet = document.querySelector('[data-cc-qa-overlay]');

  var SEARCH = root.getAttribute('data-search') || '/search';
  var HOME = (root.getAttribute('data-root') || '/').replace(/\/$/, '') + '/';
  var INDEX = root.getAttribute('data-index') || '';
  var INDEX_V = root.getAttribute('data-index-v') || '';
  var COLLS = [];
  try { COLLS = JSON.parse(root.getAttribute('data-colls') || '[]'); } catch (e) {}
  var SECTION = 'ts-search';
  var CARD = 'ts-search-card';
  var INDEX_KEY = 'ts26-search-index';
  var INDEX_TTL = 30 * 60 * 1000;
  var LIVE = 8, PAGE = 24, AUTO = 5;  // as on the collection pages: pages 2 to 5 load by themselves, then the button
  var tablet = window.matchMedia ? window.matchMedia('(min-width:750px) and (max-width:1023px)') : null;
  /* two full rows while typing: eight on phones and desktops, nine where the grid has three columns */
  function live() { return tablet && tablet.matches ? 9 : LIVE; }
  var RECENT_KEY = 'ts26-recent-searches';
  var LAST_KEY = 'ts26-search-last';
  var MIN = 2;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var touch = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  var DURATION = reduce ? 0 : 320;

  var isOpen = false, pushed = false, primed = false, skipPop = false, closeAfterSheet = false;
  var savedY = 0, lastFocus = null, hideTimer = 0, typeTimer = 0;
  var ctrl = null, seq = 0, mode = 'start', shownQ = '';
  var cache = {}, cacheKeys = [];

  /* ---------- storage (private windows can throw) ---------- */
  function store(name) {
    try { var s = window[name]; s.setItem('ts26-t', '1'); s.removeItem('ts26-t'); return s; } catch (e) { return null; }
  }
  var local = store('localStorage');
  var session = store('sessionStorage');
  function read(s, key) {
    if (!s) return null;
    try { return JSON.parse(s.getItem(key)); } catch (e) { return null; }
  }
  function write(s, key, value) {
    if (!s) return;
    try { if (value == null) s.removeItem(key); else s.setItem(key, JSON.stringify(value)); } catch (e) {}
  }

  function clean(q) { return String(q || '').replace(/\s+/g, ' ').trim(); }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function focusEl(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function say(text, el) {
    el = el || status;
    el.textContent = '';
    setTimeout(function () { el.textContent = text; }, 60);
  }

  /* ---------- recent searches ---------- */
  var ICON_CLOCK = '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="6.3"/><path d="M8 4.6V8l2.3 1.4"/></svg>';
  var ICON_X = '<svg width="9" height="9" viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true" focusable="false"><path d="M2 2l8 8M10 2 2 10"/></svg>';

  function recentItems() {
    var list = read(local, RECENT_KEY);
    if (!Array.isArray(list)) return [];
    return list.filter(function (q) { return typeof q === 'string' && clean(q).length >= MIN; }).slice(0, 6);
  }
  function remember(q) {
    q = clean(q);
    if (q.length < MIN) return;
    var low = q.toLowerCase();
    var list = recentItems().filter(function (x) { return x.toLowerCase() !== low; });
    list.unshift(q);
    write(local, RECENT_KEY, list.slice(0, 6));
  }
  function drawRecent() {
    if (!recent) return;
    var list = recentItems();
    recent.hidden = !list.length;
    recentList.innerHTML = list.map(function (q) {
      var v = esc(q);
      return '<li><button type="button" class="tss-chip tss-recent__q" data-tss-q="' + v + '">' + ICON_CLOCK + '<span>' + v + '</span></button>' +
        '<button type="button" class="tss-recent__x" data-tss-forget="' + v + '" aria-label="הסרה של ' + v + '">' + ICON_X + '</button></li>';
    }).join('');
  }

  /* ---------- urls ---------- */
  function pageUrl(q) {
    return SEARCH + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
  }
  function fullUrl(q) { return pageUrl(q) + '&section_id=' + SECTION; }
  function withSection(href) {
    try {
      var u = new URL(href, location.href);
      u.searchParams.set('section_id', SECTION);
      return u.pathname + u.search;
    } catch (e) { return href; }
  }

  /* ---------- fetching ---------- */
  function fetchText(url, signal) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { credentials: 'same-origin', signal: signal }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (text) {
      cache[url] = text;
      cacheKeys.push(url);
      if (cacheKeys.length > 40) delete cache[cacheKeys.shift()];
      return text;
    });
  }
  function pick(text) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.querySelector('.tss-r');
  }

  function stop() {
    seq++;
    clearTimeout(typeTimer);
    if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
    root.classList.remove('is-loading');
  }
  function run(url, q, nextMode, after) {
    stop();
    var id = seq;
    ctrl = window.AbortController ? new AbortController() : null;
    if (!cache[url]) root.classList.add('is-loading');
    return fetchText(url, ctrl && ctrl.signal).then(function (text) {
      if (id !== seq) return;
      root.classList.remove('is-loading');
      var node = pick(text);
      show(node, q, nextMode);
      if (after && node) after(node);
    }, function (err) {
      if (id !== seq) return;
      root.classList.remove('is-loading');
      if (err && err.name === 'AbortError') return;
      failed(q);
    });
  }

  /* ---------- states ---------- */
  function show(node, q, nextMode, count, stay) {
    if (!node) { failed(q); return; }
    var prev = results.querySelector('.tss-r');
    if (prev && prev._io) prev._io.disconnect();
    if (prev && prev._pre) prev._pre.disconnect();
    results.innerHTML = '';
    node.classList.toggle('is-fresh', !stay);
    results.appendChild(node);
    mode = nextMode;
    shownQ = q;
    var none = !!node.querySelector('.tss-none');
    root.classList.add('has-results');
    root.classList.toggle('is-none', none);
    if (!stay) scroller.scrollTop = 0;
    if (none) say('לא נמצאו תוצאות');
    else if (nextMode === 'full') {
      var n = count != null ? count : parseInt(node.getAttribute('data-count'), 10) || 0;
      say(n === 1 ? 'נמצא פריט אחד' : 'נמצאו ' + n + ' פריטים');
    } else {
      var c = count != null ? count : node.querySelectorAll('.product-block').length;
      say(c ? c + ' מוצרים מתאימים' : 'הצעות לחיפוש');
    }
    write(session, LAST_KEY, { q: q, mode: nextMode });
  }
  function failed(q) {
    results.innerHTML = '<div class="tss-r is-fresh" data-mode="error"><div class="tss-none">' +
      '<p class="tss-none__t">החיפוש לא נטען</p>' +
      '<p class="tss-none__s">אפשר לנסות שוב או לעבור לעמוד התוצאות.</p>' +
      '<div class="tss-foot"><a class="tss-btn" href="' + esc(pageUrl(q)) + '">לעמוד התוצאות</a></div></div></div>';
    mode = 'error';
    shownQ = '';
    root.classList.add('has-results', 'is-none');
  }
  function reset() {
    stop();
    mode = 'start';
    shownQ = '';
    results.innerHTML = '';
    root.classList.remove('has-results', 'is-none');
    drawRecent();
    write(session, LAST_KEY, null);
    scroller.scrollTop = 0;
  }

  /* ---------- the catalog, kept on the phone for half an hour ---------- */
  var engine = null, engineWait = null;
  function indexPage(n) {
    return fetch(INDEX + (INDEX.indexOf('?') > -1 ? '&' : '?') + 'page=' + n, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then(function (text) {
      var a = text.indexOf('<!--tss-index-->'), b = text.lastIndexOf('<!--/tss-index-->');
      if (a < 0 || b < a) throw new Error('index');
      return JSON.parse(text.slice(a + 16, b));
    });
  }
  function loadEngine() {
    if (engineWait) return engineWait;
    if (!window.TSSearchEngine || !INDEX) return Promise.reject(new Error('engine'));
    var saved = read(local, INDEX_KEY);
    var fresh = saved && saved.v === INDEX_V && Date.now() - saved.t < INDEX_TTL && Array.isArray(saved.items);
    var rows = fresh ? Promise.resolve(saved.items) : allPages();
    engineWait = rows.then(function (items) {
      engine = window.TSSearchEngine.create(items, { collections: COLLS });
      return engine;
    });
    engineWait.catch(function () { engineWait = null; });
    return engineWait;
  }
  /* the product count says how many pages there are (250 each), so they all load at once */
  function allPages() {
    var guess = Math.max(1, Math.ceil((parseInt(INDEX_V, 10) || 0) / 250)), asked = [];
    for (var p = 1; p <= guess; p++) asked.push(indexPage(p));
    return Promise.all(asked).then(function (pages) {
      var rest = [];
      for (var n = guess + 1; n <= pages[0].pages; n++) rest.push(indexPage(n));
      return Promise.all(rest).then(function (more) {
        var items = [];
        pages.concat(more).forEach(function (pg) { items = items.concat(pg.items); });
        write(local, INDEX_KEY, { v: INDEX_V, t: Date.now(), items: items });
        return items;
      });
    });
  }

  /* ---------- product cards: the site's own card, eight at a time ----------
     Each card is read and parsed once, then copied wherever it shows; the copies go in together, once per frame. */
  var cards = {}, waiting = [], busy = 0, ready = [], frame = 0;
  function cardEl(h) {
    if (cards[h]) return cards[h];
    var job = { h: h };
    var p = new Promise(function (resolve, reject) { job.resolve = resolve; job.reject = reject; });
    cards[h] = p;
    p.catch(function () { if (cards[h] === p) delete cards[h]; });
    waiting.push(job);
    pump();
    return p;
  }
  function pump() {
    while (busy < 8 && waiting.length) {
      var job = waiting.shift();
      busy++;
      fetch(HOME + 'products/' + encodeURIComponent(job.h) + '?section_id=' + CARD, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (text) {
          var el = new DOMParser().parseFromString(text, 'text/html').querySelector('product-block, .product-block');
          if (!el) throw new Error('empty');
          return el;
        })
        .then(job.resolve, job.reject)
        .then(function () { busy--; pump(); });
    }
  }
  /* cards for results that are no longer on screen stop waiting in line */
  function keepOnly(list) {
    waiting = waiting.filter(function (job) {
      if (list.indexOf(job.h) > -1) return true;
      job.reject(new Error('skipped'));
      return false;
    });
  }
  function flush() {
    frame = 0;
    var list = ready;
    ready = [];
    list.forEach(function (r) {
      var ph = r[0];
      if (!ph.parentNode) return;
      if (r[1]) {
        var c = document.importNode(r[1], true);
        c.classList.add('is-in');
        ph.parentNode.replaceChild(c, ph);
      }
      else ph.parentNode.removeChild(ph);
    });
  }
  function place(ph, el) {
    ready.push([ph, el]);
    if (!frame) frame = requestAnimationFrame(flush);
  }
  var PLACE = '<span class="tss-ph__img"></span><span class="tss-ph__line"></span><span class="tss-ph__line tss-ph__line--short"></span>';
  /* a quiet card shape in each place, replaced by the card as it arrives */
  function fill(grid, list) {
    list.forEach(function (h) {
      var ph = document.createElement('div');
      ph.className = 'tss-ph';
      ph.setAttribute('aria-hidden', 'true');
      ph.innerHTML = PLACE;
      grid.appendChild(ph);
      cardEl(h).then(function (el) { place(ph, el); }, function () { place(ph, null); });
    });
  }
  /* the next items all together, with the collection pages' soft staggered rise */
  function append(grid, els) {
    var frag = document.createDocumentFragment(), first = null, n = 0;
    els.forEach(function (el) {
      if (!el) return;
      var c = document.importNode(el, true);
      c.classList.add('is-new');
      c.style.setProperty('--d', (Math.min(n++, 11) * 0.035) + 's');
      if (!first) first = c;
      frag.appendChild(c);
    });
    grid.appendChild(frag);
    return first;
  }

  /* ---------- result views ---------- */
  var ICON_SEARCH = '<svg class="tss-row__i" width="14" height="14" viewBox="0 0 18 18" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="5.5"/><path d="M12.2 12.2 16 16"/></svg>';
  /* the words she hasn't typed yet are set in bold */
  function styled(text, q) {
    var E = window.TSSearchEngine, typed = E.words(q);
    return text.split(/(\s+)/).map(function (part) {
      if (!part.trim()) return part;
      var w = E.norm(part);
      var known = typed.some(function (t) { return w.indexOf(t) === 0 || E.stem(w) === E.stem(t); });
      return known ? esc(part) : '<mark>' + esc(part) + '</mark>';
    }).join('');
  }
  function noneHtml(q, tag) {
    tag = tag || 'p';
    return '<div class="tss-none"><' + tag + ' class="tss-none__t">לא מצאנו תוצאות ל־"' + esc(q) + '"</' + tag + '>' +
      '<p class="tss-none__s">כדאי לבדוק את האיות, לנסות מילה כללית יותר או להתחיל מאחת הקטגוריות.</p></div>';
  }
  function liveView(res, q, n) {
    var node = document.createElement('div');
    node.className = 'tss-r';
    node.setAttribute('data-mode', 'suggest');
    var hints = '';
    if (res.suggestions.length) {
      hints += '<ul class="tss-rows" role="list">' + res.suggestions.map(function (s, i) {
        var n = res.counts ? res.counts[i] : 0;
        return '<li><a class="tss-row" href="' + esc(pageUrl(s)) + '" data-tss-q="' + esc(s) + '">' + ICON_SEARCH +
          '<span class="tss-row__t">' + styled(s, q) + '</span>' + (n ? '<span class="tss-row__n">' + n + '</span>' : '') + '</a></li>';
      }).join('') + '</ul>';
    }
    if (res.collections.length) {
      hints += '<ul class="tss-rows tss-rows--coll" role="list">' + res.collections.map(function (c) {
        return '<li><a class="tss-row" href="' + esc(c.u) + '"><span class="tss-row__t">' + esc(c.t) + '</span><span class="tss-row__k">קולקציה</span></a></li>';
      }).join('') + '</ul>';
    }
    if (!res.total && !hints) {
      node.innerHTML = noneHtml(q);
      return node;
    }
    var all = res.total > n, href = esc(pageUrl(q));
    node.innerHTML = '<div class="tss-sg' + (hints ? '' : ' tss-sg--solo') + '">' +
      (hints ? '<div class="tss-sg__hints">' + hints + '</div>' : '') +
      (res.total ? '<div class="tss-sg__main">' +
        (res.fixed ? '<p class="tss-fixed">מציגים תוצאות עבור <b>' + esc(res.fixed) + '</b></p>' : '') +
        '<div class="tss-head"><span class="tss-label">' + (res.exact ? 'מוצרים' : 'התאמות קרובות') + '</span>' +
        (all ? '<a class="tss-link" href="' + href + '" data-tss-all>הצגת הכל</a>' : '') + '</div><div class="tss-grid"></div>' +
        (all ? '<div class="tss-foot"><a class="tss-btn" href="' + href + '" data-tss-all>הצגת כל ' + res.total + ' הפריטים</a></div>' : '') +
        '</div>' : '') + '</div>';
    return node;
  }
  function fullView(res, q, heading) {
    var node = document.createElement('div');
    node.className = 'tss-r';
    node.setAttribute('data-mode', 'full');
    node.setAttribute('data-count', res.total);
    if (!res.total) {
      node.innerHTML = noneHtml(q, heading === 'h1' ? 'h1' : 'p');
      return node;
    }
    var notes = [];
    if (res.fixed) notes.push('מציגים תוצאות עבור <b>' + esc(res.fixed) + '</b>');
    if (!res.exact) notes.push('אין התאמה מדויקת לכל המילים, אלה הכי קרובים');
    node.innerHTML = '<div class="tss-sum"><' + heading + ' class="tss-sum__q">' + esc(q) + '</' + heading + '>' +
      '<span class="tss-sum__n">' + (res.total === 1 ? 'פריט אחד' : res.total + ' פריטים') + '</span></div>' +
      (notes.length ? '<p class="tss-sum__note">' + notes.join('. ') + '</p>' : '') +
      '<div class="tss-grid tss-grid--full"></div>' +
      '<div class="tss-more"><i class="tss-more__emb" aria-hidden="true"></i><p class="tss-more__txt"></p>' +
      '<div class="tss-more__bar" aria-hidden="true"><i></i></div>' +
      '<button type="button" class="tss-btn tss-btn--line tss-more__btn" data-tss-more>טעינת פריטים נוספים</button></div>';
    node._list = res.list;
    node._shown = 0;
    return node;
  }
  /* the first 24 of a full view (or as many as she had before going to a product) */
  function grow(node, upTo) {
    var from = node._shown, to = Math.min(node._list.length, Math.max(upTo || 0, PAGE));
    if (to > from) {
      fill(node.querySelector('.tss-grid--full'), node._list.slice(from, to));
      node._shown = to;
    }
    tally(node);
  }
  function tally(node) {
    var box = node.querySelector('.tss-more'), list = node._list, to = node._shown;
    if (!box) return;
    if (to >= list.length) { box.parentNode.removeChild(box); return; }
    box.querySelector('.tss-more__txt').textContent = 'מציגים ' + to + ' מתוך ' + list.length + ' פריטים';
    box.querySelector('.tss-more__bar i').style.width = (to * 100 / list.length) + '%';
    watch(node);
  }
  /* the next 24 load by themselves as the end comes near, with the emblem on screen for a moment; after page 5, the button */
  function watch(node) {
    if (node._io) { node._io.disconnect(); node._io = null; }
    if (node._pre) { node._pre.disconnect(); node._pre = null; }
    var box = node.querySelector('.tss-more'), io = window.IntersectionObserver;
    var on = !!(box && io && node._shown < AUTO * PAGE);
    if (box) box.classList.toggle('is-auto', on);
    if (!box || !io) return;
    var scope = root.contains(node) ? scroller : null;
    /* a few screens before the end, the next cards start loading quietly, so they are ready when she gets there */
    node._pre = new io(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      node._pre.disconnect();
      node._pre = null;
      node._list.slice(node._shown, node._shown + PAGE).forEach(function (h) { cardEl(h).catch(function () {}); });
    }, { root: scope, rootMargin: '0px 0px 1600px 0px' });
    node._pre.observe(box);
    if (!on) return;
    node._io = new io(function (entries) {
      if (!entries.some(function (e) { return e.isIntersecting; })) return;
      node._io.disconnect();
      node._io = null;
      next(node);
    }, { root: scope, rootMargin: '0px 0px 240px 0px' });
    node._io.observe(box);
  }
  function next(node, btn, byKeyboard) {
    var box = node.querySelector('.tss-more');
    if (!box || node._busy) return;
    node._busy = true;
    if (btn) btn.classList.add('is-loading');
    var from = node._shown, to = Math.min(node._list.length, from + PAGE);
    var wait = new Promise(function (ok) { setTimeout(ok, box.classList.contains('is-auto') ? 1100 : 0); });
    var els = Promise.all(node._list.slice(from, to).map(function (h) {
      return cardEl(h).catch(function () { return null; });
    }));
    Promise.all([els, wait]).then(function (r) {
      node._busy = false;
      if (!node.parentNode) return;
      var first = append(node.querySelector('.tss-grid--full'), r[0]);
      node._shown = to;
      if (btn) btn.classList.remove('is-loading');
      tally(node);
      var page = node.closest('.tss');
      say('מציגים ' + to + ' פריטים', page === root ? status : page && page.querySelector('.tss__status'));
      if (byKeyboard && first) focusEl(first.querySelector('.product-block__detail a, a[href]'));
    });
  }

  function suggest(raw, after) {
    var q = clean(raw);
    stop();
    var id = seq;
    if (!engine) root.classList.add('is-loading');
    loadEngine().then(function (eng) {
      if (id !== seq) return;
      root.classList.remove('is-loading');
      var res = eng.search(raw, { typing: true });
      /* how many each suggestion would bring */
      res.counts = res.suggestions.map(function (s) { return eng.search(s, { typing: true }).total; });
      var n = live(), node = liveView(res, q, n);
      var list = res.list.slice(0, n), key = list.join('|');
      var grid = node.querySelector('.tss-grid');
      /* another letter that leaves the same products on top keeps their cards and her scroll spot */
      var old = mode === 'suggest' && results.querySelector('.tss-grid[data-list]');
      var same = !!(grid && old && old.getAttribute('data-list') === key);
      keepOnly(list);
      if (same) {
        Array.prototype.forEach.call(old.querySelectorAll('.is-in'), function (c) { c.classList.remove('is-in'); });
        grid.parentNode.replaceChild(old, grid);
      }
      else if (grid) grid.setAttribute('data-list', key);
      show(node, q, 'suggest', res.total, same);
      if (grid && !same) fill(grid, list);
      if (after) after(node);
    }, function () {
      if (id === seq) run(fullUrl(q), q, 'full', after);
    });
  }
  function full(raw, after) {
    var q = clean(raw);
    if (!q) { focusEl(input); return; }
    input.value = q;
    clearBtn.hidden = false;
    remember(q);
    if (touch) input.blur();
    stop();
    var id = seq;
    if (!engine) root.classList.add('is-loading');
    loadEngine().then(function (eng) {
      if (id !== seq) return;
      root.classList.remove('is-loading');
      /* same reading as while typing, so Enter shows what she was already looking at, in full */
      var res = eng.search(q, { typing: true });
      var node = fullView(res, q, 'h2');
      keepOnly(res.list.slice(0, PAGE));
      show(node, q, 'full', res.total);
      if (res.total) grow(node);
      if (after) after(node);
    }, function () {
      if (id === seq) run(fullUrl(q), q, 'full', after);
    });
  }
  /* "load more", in the live search and on the search page */
  function more(btn, byKeyboard) {
    var box = btn.closest('.tss-more');
    var scope = btn.closest('.tss-r') || results;
    var grid = scope.querySelector('.tss-grid--full');
    if (!box || !grid || btn.classList.contains('is-loading')) return;
    var inSearch = root.contains(btn);
    var page = btn.closest('.tss');
    if (scope._list) { next(scope, btn, byKeyboard); return; }
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    var id = seq;
    fetchText(withSection(btn.getAttribute('data-tss-more'))).then(function (text) {
      if (inSearch && id !== seq) return;
      var node = pick(text);
      var next = node && node.querySelector('.tss-grid--full');
      if (!next) throw new Error('empty');
      var first = next.firstElementChild;
      while (next.firstElementChild) grid.appendChild(next.firstElementChild);
      var nextBox = node.querySelector('.tss-more');
      if (nextBox) box.parentNode.replaceChild(nextBox, box); else box.parentNode.removeChild(box);
      var shown = grid.querySelectorAll('.product-block').length;
      say(shown + ' פריטים מוצגים', inSearch ? status : page && page.querySelector('.tss__status'));
      if (first && document.activeElement === btn) focusEl(first.querySelector('.product-block__detail a, a[href]'));
    }).catch(function () {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    });
  }

  /* ---------- first open: images, font, new in ---------- */
  function prime() {
    drawRecent();
    loadEngine().catch(function () {});
    if (primed) return;
    primed = true;
    var imgs = root.querySelectorAll('img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].setAttribute('src', imgs[i].getAttribute('data-src'));
      imgs[i].removeAttribute('data-src');
    }
    var font = root.getAttribute('data-font');
    if (font && !document.querySelector('link[href="' + font + '"]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = font;
      document.head.appendChild(link);
    }
    if (newRail) {
      fetchText(HOME + '?section_id=' + SECTION).then(function (text) {
        var node = pick(text);
        var rail = node && node.querySelector('.tss-rail');
        if (rail && rail.children.length) newRail.appendChild(rail);
        else if (newBox) newBox.hidden = true;
      }).catch(function () { if (newBox) newBox.hidden = true; });
    }
  }

  /* ---------- page scroll lock (same approach as the menu) ---------- */
  function pin() {
    var s = document.body.style;
    document.body.classList.remove('show-search');
    html.classList.add('tss-locked');
    s.position = 'fixed'; s.top = (-savedY) + 'px'; s.left = '0'; s.right = '0'; s.width = '100%';
  }
  function lock() {
    /* opened from the menu, the page is still held by the menu: keep the same spot */
    var b = document.body.style;
    savedY = b.position === 'fixed' ? (-parseFloat(b.top) || 0) : (window.pageYOffset || html.scrollTop || 0);
    pin();
  }
  function unlock() {
    var s = document.body.style;
    html.classList.remove('tss-locked');
    s.position = ''; s.top = ''; s.left = ''; s.right = ''; s.width = '';
    window.scrollTo(0, savedY);
  }

  /* ---------- open / close ---------- */
  function open(trigger, opts) {
    opts = opts || {};
    clearTimeout(hideTimer);
    if (isOpen) { if (!opts.quiet) focusEl(input); return; }
    isOpen = true;
    lastFocus = trigger || document.activeElement;
    root.classList.toggle('is-instant', !!opts.instant);
    root.hidden = false;
    /* a history entry of its own, so Back closes the search (pushed before the lock, so the page keeps its scroll spot) */
    if (!opts.restore) {
      try { history.pushState(Object.assign({}, history.state, { tss: 1 }), ''); pushed = true; } catch (e) { pushed = false; }
    }
    lock();
    /* focus inside the tap itself, so phones raise the keyboard */
    if (!opts.quiet) focusEl(input);
    void root.offsetWidth;
    root.classList.add('is-open');
    prime();
    /* from the search page: carry its words over, selected, so typing replaces them */
    var pre = clean(trigger && trigger.getAttribute ? trigger.getAttribute('data-tss-prefill') : '');
    if (pre) {
      input.value = pre;
      clearBtn.hidden = false;
      try { input.setSelectionRange(0, pre.length); } catch (e) {}
      if (pre.length >= MIN) suggest(pre);
    }
  }
  function close(how) {
    if (!isOpen) return;
    isOpen = false;
    closeAfterSheet = false;
    clearTimeout(typeTimer);
    root.classList.remove('is-open', 'is-instant');
    if (root.contains(document.activeElement)) document.activeElement.blur();
    unlock();
    hideTimer = setTimeout(function () { root.hidden = true; }, DURATION);
    write(session, LAST_KEY, null);
    if (how !== 'pop') {
      if (pushed) { skipPop = true; history.back(); }
      else if (history.state && history.state.tss) {
        var st = Object.assign({}, history.state);
        delete st.tss;
        try { history.replaceState(st, ''); } catch (e) {}
      }
    }
    pushed = false;
    if (how !== 'pop' && how !== 'away' && lastFocus && document.body.contains(lastFocus)) focusEl(lastFocus);
  }

  /* header icons, and the search row in the mobile menu (it clicks the header icon) */
  window.tsSearchOpen = function (t, e) { open(t, { instant: !(e && e.isTrusted) }); };
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.show-search-link, [data-tss-open]') : null;
    if (!t || root.contains(t)) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    open(t, { instant: !e.isTrusted });
  }, true);
  /* a tap that came before this script was ready (kept by snippets/ts-search.liquid) */
  if (window.tsSearchPending) {
    var early = window.tsSearchPending;
    window.tsSearchPending = null;
    open(early, { instant: true });
  }

  /* the catalog starts loading the moment a finger lands on a search icon or the menu button */
  ['pointerdown', 'focusin'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var t = e.target && e.target.closest ? e.target.closest('.show-search-link, [data-tss-open], .mobile-nav-toggle, [data-tsm-trigger]') : null;
      if (t) loadEngine().catch(function () {});
    }, true);
  });

  /* ---------- typing ---------- */
  input.addEventListener('input', function () {
    var q = clean(input.value);
    clearBtn.hidden = !input.value;
    clearTimeout(typeTimer);
    /* letters only: on the way to ג'ינס, ג' alone is not a search yet */
    if (q.replace(/[^0-9a-zA-Zא-ת]/g, '').length < MIN) { reset(); return; }
    var raw = input.value;
    typeTimer = setTimeout(function () { suggest(raw); }, 120);
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    full(input.value);
  });
  clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    reset();
    focusEl(input);
  });

  /* ---------- clicks inside ---------- */
  function plain(e) { return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button > 0); }
  root.addEventListener('click', function (e) {
    var t = e.target;
    var el = t.closest('[data-tss-close]');
    if (el) { e.preventDefault(); close(); return; }
    el = t.closest('[data-tss-more]');
    if (el) { e.preventDefault(); more(el, e.detail === 0); return; }
    el = t.closest('[data-tss-forget]');
    if (el) {
      e.preventDefault();
      var gone = el.getAttribute('data-tss-forget');
      write(local, RECENT_KEY, recentItems().filter(function (q) { return q !== gone; }));
      drawRecent();
      return;
    }
    el = t.closest('[data-tss-clear-recent]');
    if (el) { e.preventDefault(); write(local, RECENT_KEY, null); drawRecent(); focusEl(input); return; }
    el = t.closest('[data-tss-q]');
    if (el && plain(e)) { e.preventDefault(); full(el.getAttribute('data-tss-q')); return; }
    el = t.closest('[data-tss-all]');
    if (el && plain(e)) { e.preventDefault(); full(input.value || shownQ); return; }
    el = t.closest('a[href]');
    if (el && !el.closest('[data-cc-quick-add]')) {
      /* leaving for a product or collection: keep the query, so Back returns to these results */
      var q = clean(input.value);
      if (q.length >= MIN) remember(q);
      var view = results.querySelector('.tss-r');
      write(session, LAST_KEY, shownQ ? { q: shownQ, mode: mode, y: scroller.scrollTop, page: savedY, n: view && view._shown || 0 } : null);
    }
  });

  /* ---------- keyboard ---------- */
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (sheet && !sheet.hidden) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(
      root.querySelectorAll('a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([type="hidden"])'),
      function (el) { return el.getClientRects().length > 0; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (!root.contains(document.activeElement)) { e.preventDefault(); focusEl(first); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); focusEl(last); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); focusEl(first); }
  });

  /* ---------- a finger on the results puts the keyboard away ----------
     at the first touch, before the swipe is read, so the same swipe goes on to scroll the results */
  scroller.addEventListener('touchstart', function () {
    if (document.activeElement === input) input.blur();
  }, { passive: true });
  scroller.addEventListener('scroll', function () {
    root.classList.toggle('is-scrolled', scroller.scrollTop > 4);
  }, { passive: true });

  /* ---------- Back button closes the search ---------- */
  /* the snippet registers the popstate listener before the page's deferred scripts run, so the search's own
     history steps never reach them (the collection page would otherwise reload its grid) */
  function onPop(e) {
    var ours = !!(e.state && e.state.tss);
    if (skipPop && !ours) {
      skipPop = false;
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      return;
    }
    if (isOpen && !ours) {
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      pushed = false;
      close('pop');
    } else if (!isOpen && ours) {
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      open(null, { quiet: true, restore: true });
      pushed = true;
    }
  }
  if (window.tsSearchHook) window.tsSearchPop = onPop;
  else window.addEventListener('popstate', onPop);

  /* ---------- living with the quick add sheet and the cart ---------- */
  if (sheet && window.MutationObserver) {
    /* the sheet locks and unlocks the page on its own; once it closes over the search, lock again */
    new MutationObserver(function () {
      if (!isOpen || !sheet.hidden) return;
      if (closeAfterSheet) { closeAfterSheet = false; close('away'); return; }
      pin();
    }).observe(sheet, { attributes: true, attributeFilter: ['hidden'] });
  }
  document.addEventListener('on:cart-drawer:before-open', function () {
    if (!isOpen) return;
    if (sheet && !sheet.hidden) closeAfterSheet = true;
    else close('away');
  });

  /* ---------- the search page (/search) ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-tss-page] [data-tss-more]') : null;
    if (!el || !plain(e)) return;
    e.preventDefault();
    more(el, e.detail === 0);
  });
  /* the page arrives with the store's own results; the same matching as the live search replaces them */
  var pageRoot = document.querySelector('[data-tss-page]');
  var pageQ = pageRoot ? clean(pageRoot.getAttribute('data-q')) : '';
  if (pageQ) {
    remember(pageQ);
    loadEngine().then(function (eng) {
      var res = eng.search(pageQ, { typing: true });
      var node = fullView(res, pageQ, 'h1');
      var server = pageRoot.querySelector('.tss-r');
      if (server) server.parentNode.replaceChild(node, server);
      var start = pageRoot.querySelectorAll('[data-tss-page-start]');
      for (var i = 0; i < start.length; i++) start[i].hidden = !!res.total;
      /* the tab title still counts the store's own results */
      document.title = document.title.replace(/\d+/, res.total);
      if (res.total) grow(node);
      else pageRail();
    }).catch(function () {}).then(function () {
      pageRoot.classList.remove('is-pending');
    });
  }
  function pageRail() {
    var rail = pageRoot.querySelector('[data-tss-page-new]');
    if (!rail || rail.children.length) return;
    fetchText(HOME + '?section_id=' + SECTION).then(function (text) {
      var node = pick(text);
      var list = node && node.querySelector('.tss-rail');
      if (list) while (list.firstElementChild) rail.appendChild(list.firstElementChild);
    }).catch(function () {});
  }

  /* ---------- coming back from a product with Back ---------- */
  (function restore() {
    var st = history.state;
    if (!st || !st.tss) return;
    var last = read(session, LAST_KEY);
    open(null, { quiet: true, restore: true, instant: true });
    if (!last || !last.q) return;
    if (last.page) { savedY = last.page; pin(); }
    input.value = last.q;
    clearBtn.hidden = false;
    var done = function (node) {
      if (node && node._list && last.n > node._shown) grow(node, last.n);
      if (last.y) scroller.scrollTop = last.y;
    };
    if (last.mode === 'full') full(last.q, done);
    else suggest(last.q, done);
  })();
})();
